import ShellBrandHeader from "./ShellBrandHeader";
import TopNavigation from "./TopNavigation";
import GlobalSearchEntry from "./GlobalSearchEntry";
import NotificationsEntry from "./NotificationsEntry";
import UserProfileMenu from "./UserProfileMenu";
import styles from "./shell.module.css";
import { cn } from "../utils/cn";

/** Fixed top header: brand, desktop nav, search, notifications, profile. */
export default function TopHeader({ className, hideDesktopNav = false }) {
  return (
    <header className={cn(styles.header, className)}>
      <div className={styles.headerInner}>
        <ShellBrandHeader size="header" />
        {hideDesktopNav ? null : <TopNavigation />}
        <div className={styles.headerActions}>
          <GlobalSearchEntry />
          <NotificationsEntry />
          <UserProfileMenu />
        </div>
      </div>
    </header>
  );
}
